function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Brackets_Black"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.47 56l18.72-14.97-18.72-15.05 4.57-3.66 23.37 18.7-23.03 18.91L32.47 56zM27.39 41.66L4.36 22.75l23.37-18.7 4.57 3.66-18.71 15.04L32.3 37.73l-4.91 3.93z"
}))));